import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn', 'isAppLogin']),
}

export const authMutations = mapMutations('auth', ['SET_CURRENT_USER', 'SET_APP_LOGIN'])

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'register',
  'requestPasswordReset',
  'performPasswordReset',
  'validate'
])
export const userMethods = mapActions('users', ['updateUser', 'getDropHistory', 'cancelSubscription'])
export const tagMethods = mapActions('tags', ['getTags', 'getOptIns'])
export const purchaseMethods = mapActions('purchases', [
  'createCheckoutSession',
  'getAvailablePrices',
])
export const notificatonServicesMethods = mapActions('notificationServices', [
  'getNotificationServices',
])
export const productMethods = mapActions('products', [
  'getProduct',
  'subscribeToProduct',
  'unsubscribeToProduct',
  'subscribeToProductSource',
  'unsubscribeToProductSource',
  'searchForProducts',
  'getMyProduts',
  'getCustomTrackers',
  'addTracker',
  'deleteTracker'
])
